import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Error500Service } from '../services/error-500.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const Error500Interceptor: HttpInterceptorFn = (req, next) => {
  const error500Service = inject(Error500Service);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 500) {
        error500Service.showError500Modal();
      }
      return throwError(() => error);
    })
  );
};
